/** Only digits, commas and dots may be typed into the number field. */
export function DigitCommaDotFormatter(value: string): string {
  return value.replace(/[^\d.,]/g, '')
}
